module.exports = __webpack_public_path__ + "img/physiotherapy_sign_up.302dcdc3.png";